<template>
	<div>
		<Jcarcontent></Jcarcontent>
		<xfooter></xfooter>
	</div>
</template>
<script>
	import Jcarcontent from "../component/jcarcontent.vue";
	import xfooter from "../component/xfooter.vue";
	
	export default {
		components:{
			Jcarcontent,
			xfooter
		}
	}
</script>
<style>
	
</style>


// WEBPACK FOOTER //
// pcar.vue?e6740c8c